const DEFAULT_SHIFT_TYPES = ["Morning Shift", "Evening Shift"];

export const normalizeShiftTypes = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return Array.from(
      new Set(value.filter((item): item is string => typeof item === "string"))
    );
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return Array.from(
          new Set(parsed.filter((item): item is string => typeof item === "string"))
        );
      }
    } catch {
      // Fallback to comma-separated string
      return Array.from(
        new Set(
          value
            .split(",")
            .map((v) => v.trim())
            .filter(Boolean)
            .filter((item): item is string => typeof item === "string")
        )
      );
    }
  }

  return DEFAULT_SHIFT_TYPES;
};

// Optional helper to get options for dropdowns
export const getShiftTypesOptions = (value: unknown): { value: string; label: string }[] => {
  const types = normalizeShiftTypes(value);
  return types.map((type) => ({ value: type, label: type }));
};
